import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FooterComponent } from '../../components/footer.component/footer.component';
import { NavComponent } from '../../components/nav.component/nav.component';
import { AuthService } from '../../services/auth.service';

type VerificationStatus = 'loading' | 'success' | 'error' | 'no-token';

@Component({
  selector: 'app-verify-email',
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NavComponent,
    FooterComponent
  ],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
})
export class VerifyEmailComponent implements OnInit {
  status: VerificationStatus = 'loading';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.status = 'no-token';
      return;
    }

    this.verifyEmail(token);
  }

  private verifyEmail(token: string): void {
    this.authService.verifyEmail(token)
      .subscribe({
        next: () => {
          this.status = 'success';
        },
        error: (err) => {
          this.status = 'error';
          this.errorMessage = err.error?.message || 'Failed to verify email. The link may be invalid or expired.';
        }
      });
  }
}
